(() => {
  'use strict';

  if (window.__mellerPredictiveSearchLoaderReady === true) return;

  const currentScript = document.currentScript;
  const predictiveSearchSrc = currentScript?.dataset?.mellerPredictiveSearchSrc || '';

  if (!predictiveSearchSrc) return;

  window.__mellerPredictiveSearchLoaderReady = true;

  const controller = 'AbortController' in window ? new AbortController() : null;
  const listenerOptions = controller
    ? { capture: true, passive: true, signal: controller.signal }
    : { capture: true, passive: true };

  let loadPromise = null;

  const isPredictiveSearchReady = () => {
    return Boolean(customElements.get('predictive-search-component'));
  };

  const cleanupIntentListeners = () => {
    if (controller) {
      controller.abort();
    }
  };

  if ('customElements' in window) {
    customElements
      .whenDefined('predictive-search-component')
      .then(cleanupIntentListeners)
      .catch(() => {});
  }

  const loadPredictiveSearch = () => {
    if (isPredictiveSearchReady()) {
      cleanupIntentListeners();
      return Promise.resolve();
    }

    if (loadPromise) {
      return loadPromise;
    }

    loadPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(
        'script[src="' + predictiveSearchSrc + '"]'
      );

      if (existingScript) {
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });

        window.setTimeout(resolve, 1200);
        return;
      }

      const script = document.createElement('script');

      script.src = predictiveSearchSrc;
      script.type = 'module';
      script.fetchPriority = 'low';
      script.dataset.mellerLazyPredictiveSearch = 'true';

      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });

      document.head.appendChild(script);
    });

    return loadPromise;
  };

  window.__mellerLoadPredictiveSearch = loadPredictiveSearch;

  const isSearchIntentTarget = (target) => {
    if (!(target instanceof Element)) return false;

    return Boolean(
      target.closest(
        '#search-modal, predictive-search-component, [aria-controls="search-modal"], .search-modal__button, .search-action, form[action*="/search"]'
      )
    );
  };

  const handleIntent = (event) => {
    if (!isSearchIntentTarget(event.target)) return;

    loadPredictiveSearch().catch(() => {});
  };

  const handleInputReplay = (event) => {
    const target = event.target;

    if (!(target instanceof HTMLInputElement)) return;
    if (!target.closest('predictive-search-component')) return;
    if (isPredictiveSearchReady()) return;

    loadPredictiveSearch()
      .then(() => {
        window.requestAnimationFrame(() => {
          target.dispatchEvent(new Event('input', { bubbles: true }));
        });
      })
      .catch(() => {});
  };

  document.addEventListener('pointerdown', handleIntent, listenerOptions);
  document.addEventListener('focusin', handleIntent, controller ? { passive: true, signal: controller.signal } : { passive: true });
  document.addEventListener('keydown', handleIntent, controller ? { capture: true, signal: controller.signal } : { capture: true });
  document.addEventListener('input', handleInputReplay, listenerOptions);
})();
